export default __webpack_public_path__ + "static/media/twitter.a32db65d.svg";